import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { BsEye, BsEyeSlash } from 'react-icons/bs';

function TextInput({
  className,
  value,
  name,
  readOnly,
  onBlur,
  disabled,
  onKeyPress,
  onKeyDown,
  minDate,
  maxDate,
  type,
  onChange,
  label,
  placeholder,
  error,
  labelClassName,
  inputClassName
}) {
  const [inputType, setInputType] = useState(type);

  return (
    <div className={`${className} relative`}>
      <label
        htmlFor={name}
        className={`${labelClassName} flex text-labelColor mb-1`}
      >
        {label}
      </label>

      <input
        className={`${
          error ? 'error-field' : ''
        }  bg-Apurple rounded-[15px] h-12 px-3 outline-none w-full border border-borderColor text-white font-semibold ${inputClassName}`}
        type={inputType}
        name={name}
        id={name}
        value={value}
        onChange={onChange}
        readOnly={readOnly}
        placeholder={placeholder}
        onBlur={onBlur}
        disabled={disabled}
        onKeyPress={onKeyPress}
        onKeyDown={onKeyDown}
        min={minDate}
        max={maxDate}
      />

      {error ? <p className="error-msg">{error}</p> : null}

      {type === 'password' && (
        <span className="absolute right-4 bottom-3 items-center text-gray-700">
          {inputType === 'password' ? (
            <BsEye
              className="w-5 h-auto cursor-pointer items-center text-[#B5B6B6]"
              onClick={() => setInputType('text')}
            />
          ) : (
            <BsEyeSlash
              className="w-5 h-auto cursor-pointer"
              onClick={() => setInputType('password')}
            />
          )}
        </span>
      )}
    </div>
  );
}
TextInput.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  name: PropTypes.string,
  readOnly: PropTypes.bool,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  onKeyPress: PropTypes.func,
  onKeyDown: PropTypes.func,
  minDate: PropTypes.number,
  maxDate: PropTypes.number,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  labelClassName: PropTypes.string,
  inputClassName: PropTypes.string
};

TextInput.defaultProps = {
  className: '',
  type: 'text',
  onChange: () => {},
  value: '',
  name: '',
  readOnly: false,
  onBlur: () => {},
  disabled: false,
  onKeyPress: () => {},
  onKeyDown: () => {},
  minDate: undefined,
  maxDate: undefined,
  label: '',
  placeholder: '',
  error: undefined,
  labelClassName: '',
  inputClassName: ''
};
export default TextInput;
